import { CommunityDetailPage } from '@communities/community/pages';
import { ContentSearchPage } from '@content-search/pages';
import { AuthenticatedRoute } from '@core/components';
import { getCommunityAuditRouteConfig } from '@internal-audit/routeConfig';
import { ClassificationTestingPage } from '@soteria-ui/src/classification-testing/pages/ClassificationTestingPage';
import type { RouteObject } from 'react-router-dom';

import { CommunityGroupDetailPage, CommunityGroupsPage } from './community-groups/pages';
import { routes } from './routes';

/**
 * Get route configuration for the communities domain
 * @returns Array of route objects for the communities domain
 */
export function getRouteConfig(): RouteObject[] {
  return [
    // Community Groups route
    {
      path: routes.communityGroups.root.substring(1), // Remove leading slash
      element: <AuthenticatedRoute />,
      children: [
        {
          index: true,
          element: <CommunityGroupsPage />,
        },
        {
          path: ':groupId',
          element: <CommunityGroupDetailPage />,
        },
      ],
    },
    // Communities route
    {
      path: routes.communities.root.substring(1), // Remove leading slash
      element: <AuthenticatedRoute />,
      children: [
        {
          path: ':communityId',
          children: [
            {
              index: true,
              element: <CommunityDetailPage />,
            },
            {
              path: 'classification-testing',
              element: <ClassificationTestingPage />,
            },
            {
              path: 'content-search',
              element: <ContentSearchPage />,
            },
            ...getCommunityAuditRouteConfig(),
          ],
        },
      ],
    },
  ];
}
